import { em } from 'polished'
import styled from 'styled-components'

import DiscountLabelNew from 'components/DiscountLabelNew'
import { PriceMedium } from 'styles/components/typography'

export const CrossedCostBlock = styled.div`
  position: relative;
  margin-bottom: -${em(3)};
  line-height: 0;
  white-space: nowrap;
`

export const MutedCostBox = styled.span`
  opacity: 0.2;

  & ${PriceMedium} {
    font-family: ${p => p.theme.typography.baseFont};

    ${p => p.theme.mq.upMd} {
      font-family: ${p => p.theme.typography.baseFont};
    }
  }
`

export const CostBlock = styled.div`
  display: block;
  line-height: 0;
`

export const PriceWrapper = styled.div`
  ${p => p.theme.mq.upLg} {
    ${p =>
      p.inRow &&
      `
      display: flex;
    `}
  }
`

export const DiscountLabelNewStyled = styled(DiscountLabelNew)`
  position: absolute;
  top: initial;
  right: ${em(10)};
  margin-top: ${em(4)};

  ${p => p.theme.mq.upMd} {
    position: static;
    margin-top: ${em(4)};
  }

  ${p => p.theme.mq.upLg} {
    margin-top: ${em(5)};
  }
`
